import { render, staticRenderFns } from "./PersonalProfileForm.vue?vue&type=template&id=8754131e&scoped=true"
import script from "./PersonalProfileForm.vue?vue&type=script&lang=js"
export * from "./PersonalProfileForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalProfileForm.vue?vue&type=style&index=0&id=8754131e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8754131e",
  null
  
)

export default component.exports